<div class="nt" [class]="'nt nt-' + notice.kind" [class.leaving]="notice.leaving"
     [style.--life.ms]="notice.duration"
     [attr.role]="notice.kind === 'error' ? 'alert' : 'status'"
     [attr.aria-live]="live_">

  <span class="nt-icon" aria-hidden="true">
    @switch (notice.kind) {
      @case ('success') {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
             stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
      }
      @case ('error') {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
             stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
      }
      @case ('warning') {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3.6L1.8 21h20.4z"/><path d="M12 10v4.6M12 17.6h.01"/></svg>
      }
      @default {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
             stroke-linecap="round"><circle cx="12" cy="12" r="9.2"/>
          <path d="M12 11v5.4M12 7.6h.01"/></svg>
      }
    }
  </span>

  <span class="nt-body">
    <span class="nt-text">
      <span class="nt-sr">{{ label }}:</span>{{ notice.text }}
      @if (notice.count > 1) {
        <span class="nt-count" [attr.aria-label]="notice.count + ' times'">×{{ notice.count }}</span>
      }
    </span>
    @if (notice.detail) {
      <span class="nt-detail">{{ notice.detail }}</span>
    }
  </span>

  @if (notice.action) {
    <button type="button" class="nt-action" (click)="acted.emit(notice)">
      {{ notice.action.label }}
    </button>
  }

  <button type="button" class="nt-close" aria-label="Dismiss" (click)="dismissed.emit(notice)">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"
         stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
  </button>

  @if (life && notice.duration) {
    <span class="nt-life" [class.paused]="paused" aria-hidden="true"></span>
  }
</div>
